export default {
  // 获取开放场景
  getOpenSceneList: '/gateway/api/open_scene/get/',
  // 创建开放场景
  createOpenscene: '/gateway/api/open_scene/create/',
  // 更新开放场景
  updateOpenscene: '/gateway/api/open_scene/update/',
  // 删除开放场景
  deleteOpenscene: '/gateway/api/open_scene/delete/',
  // 获取团队列表
  getTeamList: '/gateway/api/team/get/',
  // 创建团队
  createTeam: '/gateway/api/team/create/',
  // 更新团队
  updateTeam: '/gateway/api/team/update/',
  // 删除团队
  deleteTeam: '/gateway/api/team/delete/',
  // 移交团队
  transformTeam: '/gateway/api/team/member/shift/',
  // 移交开放场景
  transformScene: '/gateway/api/open_scene/member/shift/',
};
